var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { touch } from 'redux-form';
import { MODAL_TYPE_SOLUTION_EDIT, showModal, } from '../../../../../actions/ModalActions';
import { apiGetOneProfessionalSolution, API_GET_ONE_PROFESSIONAL_SOLUTION, apiUpdateProfessionalSolution, } from '../../../../../actions/ProfessionalSolutionActions';
import { wrapDispatch } from '../../../../../helpers/action';
import { propArrayShape, propBool, propFunc, propShape, propMatch, propHistory, } from '../../../../../helpers/custom-prop-types';
import { isLoadingApis } from '../../../../../helpers/fetch';
import { uploadFilePromiseAndGetTemporaryId } from '../../../../../helpers/files';
import { parseParams, initialValuesForFormSolutionEdit, } from '../../../../../helpers/form_solution';
import { scrollToWithHeaderHeight } from '../../../../../helpers/ScrollUtils';
import Layout from '../../../../Layout';
import AuthenticationHoc from '../../../../System/AuthenticationHoc';
import CancelButton from '../../../../Ui/Button/CancelButton';
import SubmitButton from '../../../../Ui/Button/SubmitButton';
import { ProcessLoader } from '../../../../Ui/Loading';
import FormSolutionEdit from './FormSolutionEdit';
import ModalEditComplete from './ModalEditComplete';
const formName = 'FormSolutionEdit';
const baseMeta = { form: formName };
class Edit extends Component {
    constructor(props) {
        super(props);
        this.safeSetState = (setState) => {
            if (!this.unmount) {
                this.setState(setState);
            }
        };
        this.previewSolution = () => __awaiter(this, void 0, void 0, function* () {
            const { dispatch, formFields, professionalSolution } = this.props;
            try {
                this.safeSetState({ isLoading: true, isPreviewLoading: true });
                const params = yield this.makeParams(dispatch, formFields, 1);
                const detail = professionalSolution.detail || {};
                yield wrapDispatch(dispatch, apiUpdateProfessionalSolution(detail.id, params, baseMeta));
                window.open(`/solutions/${detail.id}?preview=on`);
            }
            finally {
                this.safeSetState({ isLoading: false, isPreviewLoading: false });
            }
        });
        this.submitSolution = () => __awaiter(this, void 0, void 0, function* () {
            const { dispatch, formFields, professionalSolution } = this.props;
            const validateResult = this.validate(dispatch, formFields);
            if (!validateResult) {
                return;
            }
            try {
                this.safeSetState({ isLoading: true, isSubmitLoading: true });
                const params = yield this.makeParams(dispatch, formFields, 2);
                const detail = professionalSolution.detail || {};
                yield wrapDispatch(dispatch, apiUpdateProfessionalSolution(detail.id, params, baseMeta));
                dispatch(showModal(MODAL_TYPE_SOLUTION_EDIT));
            }
            finally {
                this.safeSetState({ isLoading: false, isSubmitLoading: false });
            }
        });
        /**
         * 入力パラメータチェック
         * @param dispatch
         * @param formFields
         * @returns {boolean}
         */
        this.validate = (dispatch, formFields) => {
            const touchFields = [
                'title',
                'subTitle',
                'description',
                'point1',
                'point2',
                'point3',
                'solutionMiddleClassId',
                'subMiddleClasses',
                'subMiddleClasses_list',
                'tags',
                'tags_list',
                'solveIssue',
                'performance',
                'pdfFile',
                'thumbnail',
                'artifactsDescription',
                'options',
                'price',
                'period',
                'regions',
                'regions_list',
                'regionsOther',
                'caution',
            ];
            const options = _.get(formFields, 'values.options') || [];
            for (let i = 0; i < options.length; i += 1) {
                touchFields.push(`options[${i}].name`, `options[${i}].price`);
            }
            const faqs = _.get(formFields, 'values.faq') || [];
            for (let i = 0; i < faqs.length; i += 1) {
                touchFields.push(`faq.${i}.question`, `faq.${i}.answer`);
            }
            const errorViewFields = [
                'solutionMiddleClassId',
                'subMiddleClasses',
                'tags',
                'pdfFile',
                'thumbnail',
                'regions',
            ];
            touchFields.forEach((field) => dispatch(touch(formName, field)));
            const firstError = touchFields.find((field) => !!_.get(formFields, `syncErrors.${field}`));
            if (firstError) {
                if (errorViewFields.includes(firstError)) {
                    scrollToWithHeaderHeight(`${firstError}_view`);
                }
                else {
                    scrollToWithHeaderHeight(firstError);
                }
            }
            return !firstError;
        };
        this.makeParams = (dispatch, formFields, status) => __awaiter(this, void 0, void 0, function* () {
            const values = Object.assign({}, formFields.values);
            if (values.pdfFile) {
                const temporaryId = yield uploadFilePromiseAndGetTemporaryId({
                    dispatch,
                    file: values.pdfFile,
                });
                _.set(values, 'pdfFileId', temporaryId);
            }
            if (values.thumbnail) {
                const temporaryId = yield uploadFilePromiseAndGetTemporaryId({
                    dispatch,
                    file: values.thumbnail,
                });
                _.set(values, 'thumbnailFileId', temporaryId);
            }
            return parseParams(Object.assign(Object.assign({}, values), { status }));
        });
        this.state = {
            isLoading: false,
            isPreviewLoading: false,
            isSubmitLoading: false,
        };
        this.unmount = false;
    }
    componentDidMount() {
        const { loadProfessionalSolution, match: { params: { id }, }, } = this.props;
        loadProfessionalSolution(id);
    }
    componentWillUnmount() {
        this.unmount = true;
    }
    render() {
        const { history, isFirstLoading, professionalSolution, solutionMiddleClasses, } = this.props;
        const { isLoading, isPreviewLoading, isSubmitLoading } = this.state;
        const initialValues = initialValuesForFormSolutionEdit(professionalSolution, solutionMiddleClasses);
        return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main', showFooter: false }, { children: [_jsxs("div", Object.assign({ className: 'l-container l-contents' }, { children: [isFirstLoading && _jsx(ProcessLoader, {}), _jsx(FormSolutionEdit, { initialValues: initialValues })] })), _jsx(ModalEditComplete, {}), _jsx("div", Object.assign({ className: 'l-bottom-wrap preview-wrap' }, { children: _jsx("div", Object.assign({ className: 'l-bottom-fix preview-box' }, { children: _jsxs("div", Object.assign({ className: 'footer-action' }, { children: [_jsx(SubmitButton, { className: 'link-text', isDisabled: isFirstLoading || isLoading, isLoading: isPreviewLoading, onClick: this.previewSolution, text: 'プレビュー' }), _jsx(CancelButton, { className: 'btn btn-tertiary medium', isDisabled: isFirstLoading || isLoading, onClick: () => history.push('/mypage') }), _jsx(SubmitButton, { className: 'btn btn-secondary medium width-auto', isDisabled: isFirstLoading || isLoading, isLoading: isSubmitLoading, onClick: this.submitSolution, text: '変更を申請する' })] })) })) }))] })));
    }
}
Edit.propTypes = {
    dispatch: propFunc().isRequired,
    formFields: propShape().isRequired,
    history: propHistory(),
    isFirstLoading: propBool().isRequired,
    loadProfessionalSolution: propFunc().isRequired,
    match: propMatch(),
    professionalSolution: propShape().isRequired,
    solutionMiddleClasses: propArrayShape().isRequired,
};
const mapStateToProps = ({ category, fetch, form, professionalSolution }) => {
    const isFirstLoading = isLoadingApis(fetch, API_GET_ONE_PROFESSIONAL_SOLUTION);
    return {
        formFields: form[formName] || {},
        isFirstLoading,
        professionalSolution,
        solutionMiddleClasses: category.solutionMiddleClass,
    };
};
const mapDispatchToProps = (dispatch) => ({
    dispatch,
    loadProfessionalSolution: (id) => dispatch(apiGetOneProfessionalSolution(id, baseMeta)),
});
const enhance = compose(AuthenticationHoc({ isProfessional: true }), connect(mapStateToProps, mapDispatchToProps));
export default enhance(Edit);
